<script lang="ts" setup>
    import { ref, watch, computed } from "vue";
    import SearchBase  from './SearchBase.vue';
    import NewPaymentBatch  from  '../../ChoiceScreens/Billing/NewPaymentBatch.vue';
    import { paymentbatch } from '../../lib/ChoiceApi';
    import { ISearchPaymentBatchItem, ISearchPaymentBatchInputs, ISearchPaymentBatchKey, ISearchBaseInputs } from "../../lib/Models/SearchModel";

    const emit = defineEmits<{
        onChange: [selectedItem: ISearchPaymentBatchItem]
    }>()
    
    const props = withDefaults(defineProps<{
        // Placeholder text to be displayed inside text control if no values
        placeholder?: string,
        // Label for the component
        label?: string,
        // The default search value 
        defaultSearchKey?: ISearchPaymentBatchKey,
        // The maximum height of the search results
        maxHeight?: number,
        // Reset Focus
        resetFocus?: boolean,
        // Perform auto-search on text input
        enableAutoSearch?: boolean,
        // Show the clear search function
        showClearSearch?: boolean,
        // Add to Base Class
        addToBaseClass?: string,
        newButton?: boolean,
    }>(), {
        placeholder: "Search Payment Batch",
        label: "Payment Batch",
        addToBaseClass: "",
        newButton: false
    });

    const searchColumns = ref(
        [
            {title: "ID", element: "paymentBatchId"},
            {title: "Date", element: "paymentBatchDate"},
            {title: "Amount", element: "totalAmount", classStyle: 'text-end'},
            {title: "Description", element: "description"}
        ],        
    );
    const searchResults = ref<ISearchPaymentBatchItem[]>([]);
    const defaultSearchText = ref<string>("");
    const displayNewBatch = ref<boolean>(false);
    const processing = ref<boolean>(false);
    const defaultAddToBaseClass = computed<string>(() => props.addToBaseClass);

    watch(() => props.defaultSearchKey, (newValue, oldValue) => {
        defaultSearchText.value = "";
        if (newValue?.display) {
            defaultSearchText.value = newValue.display;
            const selectedItem: ISearchPaymentBatchItem = {
                paymentBatchId: newValue.paymentBatchId, 
                display: newValue.display
            };
            onChange(selectedItem);
        }
        else if (newValue?.paymentBatchId) {
            const searchInputs: ISearchPaymentBatchInputs = { 
                paymentBatchId: newValue.paymentBatchId,  
                displayAllResults: false 
            };
            processing.value = true;
            performSearch(searchInputs);
        }
        else if (newValue?.searchText) {
            defaultSearchText.value = newValue.searchText;
            const selectedItem: ISearchPaymentBatchItem = {};
            onChange(selectedItem);
            const searchInputs: ISearchPaymentBatchInputs = { 
                searchText: newValue.searchText, 
                displayAllResults: false 
            };
            processing.value = true;
            performSearch(searchInputs);
        }
        else  {
            defaultSearchText.value = "";
            const selectedItem: ISearchPaymentBatchItem = {};
            onChange(selectedItem);
        }
    });

    async function performSearch(inputs: ISearchPaymentBatchInputs) {
        const respSearch = await paymentbatch.search(inputs);
        searchResults.value = respSearch.searchList ?? [];
    }

    async function performSearchBase(inputs: ISearchBaseInputs)  {
        const searchInputs: ISearchPaymentBatchInputs = { 
            searchText: inputs.searchText,
            displayAllResults: inputs.displayAllResults
        };
        performSearch(searchInputs);
    }
    
    function onChange(selectedItem: ISearchPaymentBatchItem) {
        emit("onChange", selectedItem);
    }
    function newPaymentBatch(display: boolean) : void {
        displayNewBatch.value = display;
    }
    function CloseVueModalIframe (new_payment_batch_id : number) : void { 
        displayNewBatch.value = false;
        if (new_payment_batch_id  > 0) {
            const inputs: ISearchBaseInputs = {searchText: "*" + new_payment_batch_id.toString(), displayAllResults: false};
            performSearchBase(inputs);
        }
    }
</script>

<template>
    <SearchBase
        :placeholder="placeholder" 
        :label="label" 
        :columns="searchColumns" 
        displayColumn="display"
        :searchResults="searchResults"
        :newButton="props.newButton"
        :defaultSearchText="defaultSearchText"
        :processing="processing"
        :enableAutoSearch="enableAutoSearch"
        :showClearSearch="showClearSearch"
        :resetFocus="resetFocus"
        :addToBaseClass="defaultAddToBaseClass"
        @performSearchBase="performSearchBase"
        @onChange="onChange"
        @new="newPaymentBatch">
    </SearchBase>
    <NewPaymentBatch
        :showDialog="displayNewBatch"
        :clearDialog="displayNewBatch"
        @close-vue-modal-iframe="CloseVueModalIframe">
    </NewPaymentBatch>
</template>